import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';
import { getDateTime } from '@shared/utils';

const EMPTY_LABEL = '—';

@Pipe({ name: 'cashSessionDuration', standalone: true, pure: false })
export class CashSessionDurationPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(opened: string | null | undefined, closed?: string | null): string {
    const start = opened ? getDateTime(opened) : null;
    if (!start || !start.isValid) {
      return EMPTY_LABEL;
    }

    if (!closed) {
      return this.translate.instant('TREASURY.CASH.TURN.DURATION_IN_PROGRESS');
    }

    const end = getDateTime(closed);
    if (!end?.isValid) {
      return EMPTY_LABEL;
    }

    const totalMinutes = Math.max(0, Math.floor(end.diff(start, 'minutes').minutes));
    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes - days * 60 * 24) / 60);
    const minutes = totalMinutes - days * 60 * 24 - hours * 60;

    if (days > 0) {
      return `${days}d ${hours}h`;
    }
    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    }
    return `${minutes}m`;
  }
}
